import { render, staticRenderFns } from "./ArticleSelectLangNovotelTemplate.vue?vue&type=template&id=3d482fec&scoped=true"
import script from "./ArticleSelectLangNovotelTemplate.vue?vue&type=script&lang=js"
export * from "./ArticleSelectLangNovotelTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d482fec",
  null
  
)

export default component.exports